import React from 'react'
import styled from 'styled-components'
import { FaRegCheckSquare, FaRegSquare, FaRegGrin, FaRegMeh, FaRegSadTear } from 'react-icons/fa'
import { LgySection } from 'app/components/util/lgy-section/LgySection'
import LgyLink from 'app/components/util/lgy-link/LgyLink'
import { formatUnixDateStringToDisplayString } from 'app/utils/dateTimeUtils'
import '../style/jobs.scss'

const SuccessHighIcon = styled(FaRegGrin)`
  font-size: 20pt;
  color: green;
`

const SuccessMediumIcon = styled(FaRegMeh)`
  font-size: 20pt;
  color: orange;
`

const SuccessLowIcon = styled(FaRegSadTear)`
  font-size: 20pt;
  color: red;
`

const JobsSummary = ({ jobs }) => <div>
  <LgySection header='Jobs' className='jobs'>
    <table className='usa-table-borderless'>
      <thead>
        <tr>
          <th scope='col'>Enabled</th>
          <th scope='col'>Job</th>
          <th scope='col'>Description</th>
          <th scope='col'>Schedule</th>
          <th scope='col'>Last Status</th>       
          <th scope='col'>Last Run</th>
          <th scope='col'>Health</th>
        </tr>
      </thead>
      <tbody>

        {jobs.map(job => {

          const lastRun = job.runs.length > 0
            ? job.runs.reduce((max, run) => (run.startDate > max.startDate) ? run : max)
            : null

          const lastRunStatus = lastRun === null
            ? 'Never Ran'
            : lastRun.success === null
              ? 'Running'
              : lastRun.success
                ? 'Success'
                : 'Failure'

          const successRatePast10Runs = job.runs.slice(0, 10).reduce((successes, run) => (run.success ? successes + 1 : successes), 0) / job.runs.slice(0, 10).length

          return <tr key={job.name}>
            <td>{job.isEnabled ? <FaRegCheckSquare data-testid='jobEnabledCheckbox' size='26' /> : <FaRegSquare data-testid='jobDisabledCheckbox' size='26' />}</td>
            <td>
              <LgyLink title='Help' className='lgy-header-help' to={`/lgyhub/admin/jobs/${job.name}`}>{job.name}</LgyLink></td>
            <td>{job.description}</td>
            <td>{job.cronDescription}</td>
            <td>{lastRunStatus}</td>
            <td>{formatUnixDateStringToDisplayString(lastRun?.startDate)}</td>
            <td>{successRatePast10Runs === 1
              ? <SuccessHighIcon data-testid='jobSuccessHighIndicator'/>
              : successRatePast10Runs > .7
                ? <SuccessMediumIcon data-testid='jobSuccessMediumIndicator' />
                : <SuccessLowIcon data-testid='jobSuccessLowIndicator' />}</td>
          </tr>
        })}
      </tbody>
    </table>
  </LgySection>
</div>

export default JobsSummary
